import { useTranslation } from 'react-i18next'

import { FormModal } from '../../Form'

import {
  getDocumentEditInitialValues,
  getDocumentEditValidationSchema,
} from './DocumentEditActionModal.utils'
import { DocumentEditActionModalFields } from './DocumentEditActionModalFields'

function DocumentEditActionModal({
  formFieldsProps,
  id,
  initialValues,
  isFolder,
  onClose,
  onSubmit,
}) {
  const preparedinitialValues = getDocumentEditInitialValues(initialValues)

  const { t } = useTranslation()

  const validationSchema = getDocumentEditValidationSchema({
    initialValues: preparedinitialValues,
    isFolder,
    t,
  })

  function handleSubmit({ values }) {
    onSubmit(values, id)
  }

  return (
    <FormModal
      Fields={DocumentEditActionModalFields}
      formBodyProps={{
        withNotifications: true,
      }}
      formFieldsProps={formFieldsProps}
      formTitle='Modal.DocumentEditActionKey'
      initialValues={preparedinitialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default DocumentEditActionModal
